module.exports = __webpack_public_path__ + "img/tile-onionskins_en.6351833.jpg";